<template>
    <div class="main">
        <div class="phone-holder">
            <div class="phone-screen" :style="{backgroundImage:'url('+image+')'}"></div>

        </div>
        <div class="block" :style="{'background-color':backgroundColor}">
            <div class=icon>
               <img :src="iconUrl"/>
            </div>
            <p style="padding: 0 10px;">{{label}} </p>
        </div>
    </div>
</template>

<script>
    import icon from  "../icon.vue"
    export default {
        name: "intro-page",
        data() {
            return {}
        },
        component:{
            icon
        },
        props:{
            image:String,
            iconUrl:String,
            label:String,
            backgroundColor:String,
            itemsCount:Number,
            mainColor:String,
            selectedColor:String,
            selectedItem:Number,
        },
    }
</script>

<style scoped>
    .phone-holder{
        background:url(http://avtopoisk.kz/assets/img/phone.png);
        background-repeat:no-repeat;
        background-position: center bottom;
        background-size: 258px auto;
        padding-top:114px;
    }

    .phone-screen{
        width:224px;
        height:240px;
        margin:0 auto;
        background-size:cover;

    }
    .main{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .image{
        display: block;
        width:330px;
        margin:0 auto;
    }
    .block{
        text-align: center;
        width:100%;
        height: 1000px;
    }
    .block p {
        font-size:20px;
        color: #fff;
        font-weight: 200;
        padding: 5px 15px;
    }
    .icon{
        padding: 25px 0px;
    }

    .icon img{
        width:60px;
        height:60px;
    }
</style>